<form #templateManagerForm="ngForm">
    <label>Show In Document Types Used in
        Templates</label>
    <p-selectButton [options]="defaultSelectButtonOptions" [(ngModel)]="templateManager.visible" optionValue="value"
        name="visible"></p-selectButton>

    <p-toolbar>
        <div class="tw-text-right tw-w-[95%] tw-mt-5 tw-row-span-4">
            <button pButton [disabled]="!active || !templateManagerForm.dirty" icon="fal fa-save" label="Save"
                (click)="saveChanges($event)" class="tw-mr-2"></button>
            <button pButton [disabled]="!active || !templateManagerForm.dirty" icon="fal fa-undo" label="Cancel"
                (click)="resetForm()" class="p-button-warning p-button-outlined tw-mr-2"></button>
            <button pButton [disabled]="documentTypeId===0" icon="fal fa-trash" label="Delete"
                (click)="deleteTemplateManager()" class="p-button-warning p-button-outlined tw-mr-2"></button>
        </div>
    </p-toolbar>
</form>

<p-confirmDialog key="TemplateMgrDeleteDialog" appendTo="body" header="Delete Template Manager Configuration"
    message="Are you sure you want to delete this?" rejectButtonStyleClass="p-button-warning p-button-outlined">
</p-confirmDialog>
